<template>
    <div class="main" style="display: inline-block">
      <img class="img" :src="levelIcon" alt="等级"
           style="width: 0.15rem;position: relative; top: 2px;">
      <span class="item" >{{levelName}}</span>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  const SRC = '../../../../static/img/memberLevelIcon/';
  export default {
    name: 'MemberLevel',
    props: {
      userInfo:{
        type:Object,
        default: () => {
          return {};
        }
      }
    },
    computed:{
      ...mapGetters('user', {
        levelList: 'getMemberLevelList',
      }),
    },
    mounted () {
      this.init();
    },
    data () {
      return {
        level: '',
        levelName: '',
        levelIcon: "",
      }
    },
    methods: {
      init() { }
    },
    watch: {
      levelList: {
        handler(newVal, oldVal) {
          this.levelName = newVal[this.level];
        },
        immediate: true,
        deep: true
      },
      userInfo: {
        handler(userInfo, oldVal) {
          let level = '';
          if(userInfo.teamAgent && userInfo.teamLevel) {
            level = 'team' + userInfo.teamLevel
          } else if(userInfo.retailAgent) {
            level = "retail"
          } else {
            level = "member"
          }
          this.level = level;
          this.levelName = this.levelList[level];
          this.levelIcon = SRC + level + ".svg";
        },
        immediate: true,
        deep: true
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/userElement/components/MemberLevel.vue